import React, { Component } from 'react';
import PropTypes from 'prop-types';

var recursiveCalcElementCoords = function (element) {

  var aggOffsetLeft = 0;
  var aggOffestTop = 0;
  var objectCursor = element;

  //recursively traverse DOM element via "offsetParent" and
  //aggregate all "offsetLeft" and "offsetTop" values
  //
  //stop once "offsetParent" is null
  do {
    aggOffsetLeft += objectCursor.offsetLeft;
    aggOffestTop += objectCursor.offsetTop;
    objectCursor = objectCursor.offsetParent;
  }
  while (objectCursor)

  return {
    x: aggOffsetLeft,
    y: aggOffestTop,
  }
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var ReactBloom = function (_Component) {
  inherits(ReactBloom, _Component);

  function ReactBloom(props) {
    classCallCheck(this, ReactBloom);

    var _this = possibleConstructorReturn(this, (ReactBloom.__proto__ || Object.getPrototypeOf(ReactBloom)).call(this, props));

    _this._bloomContainer = null;
    _this._debloomTimeout = null;
    _this.state = {
      bloomPhase: 'hidden', // 'hidden, staging, blooming, resetting'
      x: 0,
      y: 0
    };
    _this.handleEngageButton = _this.handleEngageButton.bind(_this);
    _this.handleDisengageButton = _this.handleDisengageButton.bind(_this);
    _this.ignoreContextMenu = _this.ignoreContextMenu.bind(_this);
    _this.$1804017614722 = _this.$1804017614722.bind(_this);
    _this.$3466133276696 = _this.$3466133276696.bind(_this);
    return _this;
  }

  createClass(ReactBloom, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isTouchCapable = 'ontouchstart' in window || navigator.msMaxTouchPoints;

      if (isTouchCapable) return React.createElement(
        'div',
        {
          ref: function ref(_ref) {
            return _this2._bloomContainer = _ref;
          },
          onTouchStart: this.handleEngageButton,
          onTouchEnd: this.handleDisengageButton,
          onTouchCancel: this.handleDisengageButton
          // onTouchMove={this.handleDisengageButton}
          , onContextMenu: this.ignoreContextMenu,
          style: this.$1804017614722()
        },
        React.createElement('div', { style: this.$3466133276696() })
      );else return React.createElement(
        'div',
        {
          ref: function ref(_ref2) {
            return _this2._bloomContainer = _ref2;
          },
          onMouseDown: this.handleEngageButton,
          onMouseUp: this.handleDisengageButton,
          onContextMenu: this.ignoreContextMenu,
          style: this.$1804017614722()
        },
        React.createElement('div', { style: this.$3466133276696() })
      );
    }
  }, {
    key: 'handleEngageButton',
    value: function handleEngageButton(e) {
      var _this3 = this;

      var containerCoords = recursiveCalcElementCoords(this._bloomContainer);
      var hotX = e.changedTouches ? e.changedTouches[0].pageX : e.pageX;
      var hotY = e.changedTouches ? e.changedTouches[0].pageY : e.pageY;
      var x = hotX - containerCoords.x;
      var y = hotY - containerCoords.y;

      // console.log('Object.keys(this._bloomContainer)', Object.keys(this._bloomContainer));
      // console.log('containerCoords.x, containerCoords.y', containerCoords.x, containerCoords.y);
      // console.log('hotX, hotY', hotX, hotY);
      // console.log('x, y', x, y);

      clearTimeout(this._debloomTimeout);

      requestAnimationFrame(function () {

        _this3.setState({ bloomPhase: 'hidden', x: x, y: y });

        requestAnimationFrame(function () {
          return _this3.setState({ bloomPhase: 'blooming' });
        });
      });
    }
  }, {
    key: 'handleDisengageButton',
    value: function handleDisengageButton() {
      var _this4 = this;

      this.setState({ bloomPhase: 'resetting' });

      this._debloomTimeout = setTimeout(function () {

        _this4.setState({ bloomPhase: 'hidden' });
      }, this.props.animationMs * this.props.disappearCompound);
    }
  }, {
    key: 'ignoreContextMenu',
    value: function ignoreContextMenu(e) {
      e.preventDefault();
    }
  }, {
    key: '$1804017614722',
    value: function $1804017614722() {

      var defaultStyle = {
        position: 'relative',
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        outline: 'none',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
        WebkitTouchCallout: 'none',
        WebkitUserSelect: 'none',
        KhtmlUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none'
      };

      return Object.assign({}, defaultStyle, this.props.style);
    }
  }, {
    key: '$3466133276696',
    value: function $3466133276696() {
      var _this5 = this;

      var calcTransform = function calcTransform() {

        switch (_this5.state.bloomPhase) {
          case 'hidden':
            return 'none';
          case 'staging':
            return 'none';
          case 'blooming':
            return 'translateX(-' + _this5.props.bloomSize + 'px) translateY(-' + _this5.props.bloomSize + 'px)';
          case 'resetting':
            return 'translateX(-' + _this5.props.bloomSize + 'px) translateY(-' + _this5.props.bloomSize + 'px)';
          default:
            return 'hidden';
        }
      };

      var calcPadding = function calcPadding() {

        switch (_this5.state.bloomPhase) {
          case 'hidden':
            return 0;
          case 'staging':
            return 0;
          case 'blooming':
            return _this5.props.bloomSize;
          case 'resetting':
            return _this5.props.bloomSize;
          default:
            return 0;
        }
      };

      var calcTransition = function calcTransition() {

        switch (_this5.state.bloomPhase) {
          case 'hidden':
            return 'none';
          case 'staging':
            return 'none';
          case 'blooming':
            return 'transform ' + _this5.props.animationMs + 'ms ' + _this5.props.transitionTiming + ', padding ' + _this5.props.animationMs + 'ms ' + _this5.props.transitionTiming + ', opacity ' + _this5.props.animationMs + 'ms ' + _this5.props.transitionTiming;
          case 'resetting':
            // use "disappearCompound" to slow reset animation
            return 'transform ' + _this5.props.animationMs * _this5.props.disappearCompound + 'ms ' + _this5.props.transitionTiming + ', padding ' + _this5.props.animationMs * _this5.props.disappearCompound + 'ms ' + _this5.props.transitionTiming + ', opacity ' + _this5.props.animationMs * _this5.props.disappearCompound + 'ms ' + _this5.props.transitionTiming;
          default:
            return 'none';
        }
      };

      var calcOpacity = function calcOpacity() {

        switch (_this5.state.bloomPhase) {
          case 'hidden':
            return 0;
          case 'staging':
            return _this5.props.opacity;
          case 'blooming':
            return _this5.props.opacity;
          case 'resetting':
            return 0;
          default:
            return 0;
        }
      };

      return {
        position: 'absolute',
        left: this.state.x,
        top: this.state.y,
        padding: calcPadding(),
        transform: calcTransform(),
        width: 0,
        height: 0,
        backgroundColor: this.props.backgroundColor,
        opacity: calcOpacity(),
        borderRadius: '100%',
        transition: calcTransition(),
        filter: this.props.filter,
        WebKitFilter: this.props.filter
      };
    }
  }]);
  return ReactBloom;
}(Component);

ReactBloom.propTypes = {
  style: PropTypes.object,
  bloomSize: PropTypes.number,
  transitionTiming: PropTypes.string,
  animationMs: PropTypes.number,
  disappearCompound: PropTypes.number,
  backgroundColor: PropTypes.string,
  opacity: PropTypes.number
};

ReactBloom.defaultProps = {
  style: {},
  bloomSize: 100,
  transitionTiming: 'cubic-bezier(0.215, 0.61, 0.355, 1)', // "easeOutCubic"
  animationMs: 250,
  disappearCompound: 5,
  backgroundColor: 'black',
  opacity: 0.5,
  filter: 'none'
};

export default ReactBloom;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 90
// module chunks = 0